/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Careful_Duck_LendInputs */

const fr_solid_careful_duck_lend = /** @type {(inputs: Solid_Careful_Duck_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter`)
};

/**

* @param {Solid_Careful_Duck_LendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const solid_careful_duck_lend = /** @type {((inputs?: Solid_Careful_Duck_LendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Careful_Duck_LendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_solid_careful_duck_lend(inputs)
});